module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/Microscope Camera Module.56563a34.png";